import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import * as Api from "../../../appApi/AppApi";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";

function* getPartnersCarriers(payLoad) {
  try {
    const response = yield call(
      Api.makeSecuredGetRequest,
      API_ENDPOINT.GET_PARTNERS_CARRIERS
    );
    yield put(
      memberAction.createActionOf(
        memberType.GET_PARTNERS_CARRIERS_SUCCESS,
        1,
        response
      )
    );
  } catch (error) {
    yield put(
      memberAction.createActionOf(
        memberType.GET_PARTNERS_CARRIERS_FAILED,
        2,
        error
      )
    );
  }
}

export const watchGetPartnersCarrierss = takeLatest(
  memberType.GET_PARTNERS_CARRIERS,
  getPartnersCarriers
);
